import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=151d8fc4&"
import script from "./HomeButton.vue?vue&type=script&lang=js&"
export * from "./HomeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports